import React, { Component } from 'react';
import { Button, ButtonGroup, Container, Table, Form, FormGroup, Input, Label } from 'reactstrap';
import AppNavbar from '../AppNavbar';
import { Link, withRouter } from 'react-router-dom';
import Fuse from 'fuse.js';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';

class UserList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            users: [],
            isLoading: true,
            searchValue: '',
            accessToken: localStorage.getItem("accessToken")
        };
        this.remove = this.remove.bind(this);
        this.confirmDelete = this.confirmDelete.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.tokenExpired = this.tokenExpired.bind(this);
    }

    componentDidMount() {
        this.setState({isLoading: true});
        this.getUsers();

    }

    async getUsers() {
        fetch('/user', {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.state.accessToken}`
            })
        })
            .then((response) => {
                if (response.status === 200) {
                    return response.json();
                }
                else if (response.status === 401) {
                    this.tokenExpired();
                }
            })
            .then((data) => {
                this.setState({users: data, isLoading: false});
            })
    }

    confirmDelete = (id, name) => {
        confirmAlert({
            title: 'Confirm to submit',
            message: `Are you sure to delete ${name}?`,
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => this.remove(id)
                },
                {
                    label: 'No',
                    onClick: () => {}
                }
            ]
        })
    };

    tokenExpired = () => {
        confirmAlert({
            title: 'Token expired',
            message: `Please log in again to continue.`,
            buttons: [
                {
                    label: 'Login',
                    onClick: () => this.props.history.push('/')
                }
            ]
        })
    };

    async remove(id) {
        await fetch(`/user/${id}`, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.state.accessToken}`
            }
        }).then((response) => {
            if (response.status === 204) {
                this.setState({isLoading: true})
                this.getUsers()
            } else if (response.status === 401) {
                this.tokenExpired();
            }
        });
    }

    handleChange(event) {
        this.setState({searchValue: event.target.value});
    }

    render() {
        const {users, isLoading} = this.state;

        if (isLoading) {
            return <p>Loading...</p>;
        }

        let options = {
            shouldSort: true,
            threshold: 0.6,
            location: 0,
            distance: 100,
            maxPatternLength: 32,
            minMatchCharLength: 1,
            keys: [
                "name"
            ]
        };

        let fuse = new Fuse(users, options);
        let result = this.state.searchValue ? fuse.search(this.state.searchValue) : users;
        result = result ? result : [];

        return (
            <div>
                <AppNavbar/>
                <Container fluid>
                    <div className="float-right">
                        <Button color="success" tag={Link} to="/users/new">Add User</Button>
                    </div>
                    <br/>
                    <br/>
                    <div className="float-right">
                        <Form>
                            <FormGroup>
                                <Label for="search">Search</Label>
                                <Input type="text" name="search" id="search"
                                       onChange={this.handleChange} autoComplete="search"/>
                            </FormGroup>
                        </Form>
                    </div>
                    <h3>Users</h3>
                    <Table className="mt-4">
                        <thead>
                        <tr>
                            <th width="1fr">Username</th>
                            <th width="1fr">First Name</th>
                            <th width="1fr">Last Name</th>
                            <th width="1fr">Role</th>
                            <th width="1fr">Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        {result.map(user => {
                            return <tr key={user.id}>
                                <td style={{whiteSpace: 'nowrap'}}>{user.username}</td>
                                <td>{user.firstName}</td>
                                <td>{user.lastName}</td>
                                <td>{user.role.charAt(0).toUpperCase() + user.role.slice(1).toLowerCase()}</td>
                                <td>
                                    <ButtonGroup>
                                        <Button size="sm" color="primary" tag={Link} to={"/users/" + user.id}>Edit</Button>
                                        <Button size="sm" color="danger" onClick={() => this.confirmDelete(user.id, user.username)}>Delete</Button>
                                    </ButtonGroup>
                                </td>
                            </tr>
                        })}
                        </tbody>
                    </Table>
                </Container>
            </div>
        );
    }

}

export default withRouter(UserList);
